// Power Pivot not Supported Error Messages

export const UNABLE_TO_ADD_CONTENT = 'unableToAddContent';

export const THUMBNAIL = 'dynamicObjectsCannotBeAdded';

export const TEXT_AREA = 'dynamicObjectsCannotBeAddedinTextAreas';

export const ADJUSTMENTS =
  "Dynamic objects cannot be added to adjustment descriptions. Please try again, selecting the 'static object' option in the Excel add-in.";

export const BASIS_OF_PRESENTATION =
  "Dynamic objects cannot be added to the Basis of Presentation. Please try again, selecting the 'static object' option in the Excel add-in.";
